import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import LoanService from '../Service/LoanService';
import StatesService from '../Service/StatesService';

export default function useReviewLoan() {
	const [state, setState] = useState({
		_loans: null,
		_openScreen: ''
	});
	const { id } = useParams();

	const openAmortizationScreen = () => {
		setState({ ...state, _openScreen: 'AMORTIZATION_TABLE' });
	};

	const closeTable = () => {
		setState({ ...state, _openScreen: '' });
	};

	const getLoan = async () => {
		const resp = await LoanService.getLoan(id);
		const region = await StatesService.getStateById(resp.lender_state);

		resp.lender_state = region?.name;

		setState({
			...state,
			_loans: resp
		});
	};

	const getName = userObj => {
		if (!userObj) {
			return 'N/A';
		}
		return `${userObj.first_name} ${userObj.last_name}`;
	};

	const accepted_by = state._loans !== null ? state._loans?.accepted_by_user : {};
	const created_by = state._loans !== null ? state._loans?.created_by_user : {};

	useEffect(() => {
		getLoan();
	}, []);

	
	return {
		getName,
		closeTable,
		openAmortizationScreen,
		accepted_by,
		created_by,
		state
	};
}
